import getCanvas from '../helpers/getCanvas';

const addForToLabel = (html) => {
  const canvas = getCanvas(html);
  const form = canvas.querySelector('form');

  if (!form) {
    return html;
  }

  const fields = form.querySelectorAll('input[type=text], select, textarea');
  const labels = form.querySelectorAll('label:not([for])');

  if (!labels.length) {
    return html;
  }

  Array.from(fields).forEach((field, index) => {
    const label = labels[index];
    const id = `field-${Math.random().toString(36).substring(2)}`;

    if (!field.getAttribute('id')) {
      field.setAttribute('id', id);
    }

    if (label) {
      label.setAttribute('for', id);
    }
  });

  return canvas.innerHTML;
};

export default addForToLabel;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/addForToLabel.js
 **/